import { createReducer, on } from '@ngrx/store';
import { IOutstandingResponse } from '../models/outstanding.model';
import * as fromOutstandingActions from '../actions/outstanding.actions';

export interface OutstandingState {
  outstanding: IOutstandingResponse | null;
  loading: boolean;
  error: any;
}

export const outstandingFeatureKey = 'outstanding';

export const initialState: OutstandingState = {
  outstanding: null,
  loading: false,
  error: null
};

export const outstandingReducer = createReducer(
  initialState,
  on(fromOutstandingActions.loadOutstanding, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(fromOutstandingActions.loadOutstandingSuccess, (state, { response }) => ({
    ...state,
    outstanding: response,
    loading: false,
    error: null
  })),
  on(fromOutstandingActions.loadOutstandingFailure, (state, { error }) => ({
    ...state,
    outstanding: null,
    loading: false,
    error
  }))
);

export const getOutstanding = (state: OutstandingState) => state.outstanding;
export const getOutstandingLoading = (state: OutstandingState) => state.loading;
export const getOutstandingError = (state: OutstandingState) => state.error;
